// imbbs一覧ページ & 詳細 & editページ
// 詳細ページはimbbsのリストから検索する
<script setup lang="ts">
import type { KjdsListPageProps } from '@/types/appTypes'

const props = withDefaults(defineProps<KjdsListPageProps>(), {})

console.log('article: kjdsPageConfig', props.kjdsPageConfig)

const route = useRoute()
const app = useNuxtApp()
const storeArticleList = useStoreArticleList()
const storeIndex = useStoreIndex()

const pageData = {
  items: [] as CommentArticle[],
  meta: {} as ApiMeta,
  mode: null,
  searchItem: null as CommentArticle | null,
}

const setHead = () => {
  const baseTitle = '博物館・美術館 掲示板'
  const headDescription = '日本最大級のミュージアム情報サイト、アイエム［インターネットミュージアム］による、ミュージアム情報の掲示板。ミュージアムに関連する話題なら、どなたでもご利用いただけます。美術館・博物館の情報はアイエムで！'

  storeIndex.setBreadCrumbs([
    {
      text: baseTitle,
      disabled: false,
      to: { path: '/imbbs' },
    },
  ])
  const headInput = app.$makeMeta({
    title: baseTitle,
    description: headDescription,
  })
  useHead(headInput)
}

const onNewPost = () => {
  navigateTo('/imbbs?new')
}

const setItemDetail = (id: number | null) => {
  if (id === null) {
    pageData.mode = null
    pageData.searchItem = null
  } else {
    pageData.searchItem = pageData.items.find(item => item.id === id) || null
    if (pageData.searchItem === null) {
      throw createError({ statusCode: 404 })
    }
  }
}

const initPage = async () => {
  const options: KjdsFetchListOptions = { query: { ...route.query } }
  const [_resSite, _resMaster, resList] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleList.fetchList(props.kjdsPageConfig.list.mainListName, options),
  ])
  pageData.items = resList.data.articles as CommentArticle[]
  pageData.meta = resList.meta

  if (route.query.view) {
    const id = route.query.view ? app.$anyToInteger(route.query.view, null) : null
    setItemDetail(id)
    pageData.mode = 'view'
  } else if (route.query.edit) {
    const id = route.query.edit ? app.$anyToInteger(route.query.edit, null) : null
    setItemDetail(id)
    pageData.mode = 'post'
  } else if (route.query.delete) {
    const id = route.query.delete ? app.$anyToInteger(route.query.delete, null) : null
    setItemDetail(id)
    pageData.mode = 'delete'
  } else if ('new' in route.query) {
    pageData.mode = 'post'
    pageData.searchItem = null
  } else {
    pageData.mode = null
  }
}
await initPage()
setHead()
</script>

<template>
  <div class="p-articlePage">
    <h2 class="c-heading_page">
      博物館・美術館 掲示板
    </h2>

    <div
      v-show="pageData.mode === null"
      class="p-articlePage_new"
    >
      <v-btn
        color="primary"
        v-on:click="onNewPost"
      >
        <v-icon class="c-toolBtn_icon">
          mdi-lead-pencil
        </v-icon>
        新規投稿
      </v-btn>
    </div>

    <div
      v-if="pageData.mode === 'view'"
      class="p-articlePage_result"
    >
      <ImbbsDetail
        v-bind:item="pageData.searchItem"
      />
    </div>
    <div
      v-if="pageData.mode === 'post'"
      class="p-articlePage_result"
    >
      <ImbbsForm
        v-bind:item="pageData.searchItem"
      />
    </div>
    <div
      v-if="pageData.mode === 'delete'"
      class="p-articlePage_result"
    >
      <ImbbsDelete
        v-bind:item="pageData.searchItem"
      />
    </div>
    <div
      v-show="pageData.mode === null"
      class="p-articlePage_result"
    >
      <div class="p-articlePage_list">
        <ImbbsItem
          v-for="item in pageData.items"
          v-bind:key="item.id"
          v-bind:item="item"
        />
      </div>

      <Pagination
        v-bind:page="pageData.meta.page_no"
        v-bind:length="pageData.meta.total_page"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.p-articlePage {
  &_new {
    margin-top: 53px;
  }
}
</style>
